"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _lib = require("mc/lib");

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorApi = _lib.utils.ErrorApi,
    JsonFetch = _lib.utils.JsonFetch,
    Fetch = _lib.utils.Fetch,
    ParamsFetch = _lib.utils.ParamsFetch,
    generateUrl = _lib.utils.generateUrl; // ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:19:09Z                      #

// ##############################################################

/**
 * Serviska pro práci s poukazy. Generated from cz.marbes.api.es.banka.BankaPoukazService.
 */
var BankaPoukazApi = function () {
  function BankaPoukazApi() {
    (0, _classCallCheck3.default)(this, BankaPoukazApi);
  }

  (0, _createClass3.default)(BankaPoukazApi, null, [{
    key: "stornujPolozkuPoukazu",

    /**
     * Stornuje položeku poukazu.
     *
     * @param poukazPolozkaId ID položky poukazu
     */
    value: function stornujPolozkuPoukazu(poukazPolozkaId) {
      var uri = serverContextPath + ("/api/banka/polozka/" + poukazPolozkaId + "/storno");
      var headers = undefined;
      var params = {};

      return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Vygenerování dokumentu poukazu.
     *
     * @param poukazHlavickaId id hlavičky poukazu
     * @return PDF dokument
     */

  }, {
    key: "getDokumentPoukazu",
    value: function getDokumentPoukazu(poukazHlavickaId) {
      var uri = serverContextPath + ("/api/banka/vratka/bankovni/doklad/" + poukazHlavickaId);
      var params = {};
      return generateUrl(uri, params, true);
    }
  }]);
  return BankaPoukazApi;
}();

exports.default = BankaPoukazApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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